// React
import React from 'react';

// UTILS
import { toArray } from 'utils/lodashUtils';

// COMPONENTS
import ServiceProgress from 'components/ServiceCardList/ServiceProgress';
import ServiceDate from 'components/ServiceCardList/ServiceDate';
import H1 from 'components/Primatives/H1';
import PText from 'components/Primatives/PText';
import DropShadow from 'components/Primatives/DropShadow';
import FlexColumn from 'components/Primatives/FlexColumn';
import FlexRow from 'components/Primatives/FlexRow';
import BackgroundImg from 'components/Primatives/BackgroundImg';
import Strong from 'components/TextModifiers/Strong';
import StyledRouteLink from 'components/Assests/StyledRouteLink';

// INTERACTION COMPONENTS
import ClientBookingModule from 'components/Booking/ClientBookingModule';
import ProBookingModule from 'components/Booking/ProBookingModule';

// VENDOR COMPONENTS
import FontAwesomeIcon from '@fortawesome/react-fontawesome';


// CONSTANTS
import { constants } from '../../constants';

const ServiceDashboard = (props) => {
    const { service, provider, reduxLocation, activePeriods, userData, style } = props;
    // console.log('ServiceDashboard-activePeriods', activePeriods)
    // console.log('ServiceDashboard-userData', userData)

    return (
        <FlexColumn id='ServiceDashboard' style={{...styles.serviceListContainerStyles, ...style}}>
            <FlexRow style={{ flex: 'none', paddingTop: 30, paddingBottom: 60}}>
                <BackgroundImg
                    height="100px"
                    width="100px"
                    borderRadius={5}
                    // circle
                    backgroundImageURL={service.coverPhotoURL}
                    style={{marginBottom: 10, marginRight: 20, overflow: 'hidden'}}
                />     
                <FlexColumn style={{maxWidth: 500}}>
                    <H1 altDark style={{marginBottom: 0, marginTop: 0}}><Strong>{service.name}</Strong></H1>
                    <StyledRouteLink style={{ textDecoration: 'underline'}}
                        to={`/service/detail/${service._id}`}
                    >
                        View Service Details
                    </StyledRouteLink>
                    { service && service.duration > 1 &&
                        <ServiceProgress
                            activePeriods={ activePeriods }
                        />
                    }
                    { service && service.duration <= 1 &&
                        <ServiceDate
                            activePeriods={ activePeriods }
                        />
                    }
                </FlexColumn> 
            </FlexRow>
            <FlexRow style={{ alignItems: 'center', flex: 'none'}}>
                <FontAwesomeIcon 
                    icon={['fas', 'video']}
                    style={{ fontSize: '3em', marginRight: 15, color: constants.color.primaryDark }}
                />
                <H1 altDark><Strong>Consultations</Strong></H1>
            </FlexRow>
            { userData && !userData.provider &&
                <div style={{width: '100%', paddingBottom: 40}}>
                    <ClientBookingModule
                        providerData={ provider }
                        serviceSbmId={ service.SBMId }
                        location={ reduxLocation }
                        serviceId={ service._id }
                    />
                </div>
            }
            { userData && userData.provider &&
                <div id={'ProBookingModule-container'} style={{width: '100%', paddingBottom: 40}}>
                    <ProBookingModule
                        providerData={ provider }
                        serviceSbmId={ service.SBMId }
                        location={ reduxLocation }
                        serviceId={ service._id }
                    />
                </div>
            }
        </FlexColumn>
    )
}

const styles = {
    serviceListContainerStyles: {
        display: 'flex',
        flex: '2 0 0%',
        flexFlow: 'column nowrap',
        // marginRight: '5vw',
        paddingLeft: '3vw',
        paddingRight: '3vw',
        paddingBottom: 40,
        // justifyContent: 'center',
        overflow: 'scroll',
        backgroundColor: constants.color.grey5,
        minHeight: 'calc(100vh - 73px)',
        maxHeight: 'calc(100vh - 73px)'
    }
}

export default ServiceDashboard;



// WEBPACK FOOTER //
// ./src/js/containers/ServiceContainer/ServiceDashboard.jsx